import constants from '../shared/constants';

document.addEventListener('DOMContentLoaded', (): void => {
    const searchElements = document.querySelectorAll<HTMLElement>(constants.targets.menu.searchToggle);
    const searchForm = document.getElementById(constants.targets.menu.searchForm);

    if (searchForm && searchElements.length > 0) {
        searchElements.forEach((el) => {
            el.addEventListener('click', () => {
                searchForm.classList.toggle(constants.classes.active);
                document.documentElement.classList.toggle(constants.classes.searchOpen);

                const input = searchForm.querySelector<HTMLInputElement>(constants.targets.menu.input);
                const label = el.querySelector<HTMLElement>(constants.targets.menu.searchLabel);

                if (searchForm.classList.contains(constants.classes.active)) {
                    input?.focus();
                    el.classList.add(constants.classes.active);
                    if (label) label.innerHTML = el.dataset.closeText ?? '';
                } else {
                    el.classList.remove(constants.classes.active);
                    if (label) label.innerHTML = el.dataset.searchText ?? '';
                }
            });
        });

        document.addEventListener('click', (event: MouseEvent) => {
            const target = event.target as Node;
            const isClickInside = searchForm.contains(target) || Array.from(searchElements).some((element) => element.contains(target));

            if (!isClickInside) {
                searchForm.classList.remove(constants.classes.active);
                document.documentElement.classList.remove(constants.classes.searchOpen);

                searchElements.forEach((el) => {
                    el.classList.remove(constants.classes.active);
                    const label = el.querySelector<HTMLElement>(constants.targets.menu.searchLabel);
                    if (label) label.innerHTML = el.dataset.searchText ?? '';
                });
            }
        });
    }
});
